import { Button, DialogActions, Grid, Stack } from '@mui/material';
import React from 'react';

/** `documentLabel` names the document the services are added to, e.g. "Estimate" or "Work Order". */
const DialogFooter = ({ selectedCount, onCancel, onAddToInvoice, documentLabel = 'Invoice' }) => {
    return (
        <DialogActions sx={{ padding: '0!important' }}>
            <Grid item container gap={2} justifyContent={'space-between'} padding={'16px'} borderTop={'1px solid rgba(0, 0, 0, 0.12)'}>
                <Grid item>
                    <Stack spacing={2} direction={'row'}>
                        <Button variant="outlined" color="primary" onClick={onCancel}>
                            CANCEL
                        </Button>
                    </Stack>
                </Grid>
                <Grid item>
                    <Stack spacing={2} direction={'row'}>
                        <Button variant="contained" color="primary" onClick={onAddToInvoice} disabled={selectedCount === 0}>
                            ADD TO {documentLabel.toUpperCase()} {selectedCount > 0 && `(${selectedCount})`}
                        </Button>
                    </Stack>
                </Grid>
            </Grid>
        </DialogActions>
    );
};

export default DialogFooter;
